module.exports = __webpack_public_path__ + "static/media/main_travel_image.09ccdef6.png";